import React, { useState } from "react";

import Container from "../../../Components/Admin/Container";
import Button from "../../../Components/Button";
import SettingsSpotlight from "../../../Components/SettingsSpotlight";
import SettingsProductsAndMarkets from "../../../Components/SettingsProductsAndMarkets";
import SettingsTermsOfUseCDOC from "../../../Components/SettingsTermsOfUseCDOC";
import SettingsCards from "../../../Components/SettingsCards";
import SettingsPopupCookies from "../../../Components/SettingsPopupCookies";
import SettingsCDOC from "../../../Components/SettingsCDOC";

import { Main, SectionNav, NavItem } from "./styles";

function Index() {
    const [navState, setNavState] = useState(1);

    function handleNav({ target }) {
        setNavState(parseInt(target.dataset.value));
    }

    return (
        <Container pageTitle="Configurações">
            <Main>
                <nav className="row">
                    <NavItem>
                        <Button
                            variant="success"
                            disabled={navState === 1}
                            data-value="1"
                            onClick={handleNav}
                        >
                            Destaques
                        </Button>
                    </NavItem>
                    <NavItem>
                        <Button
                            variant="success"
                            data-value="2"
                            disabled={navState === 2}
                            onClick={handleNav}
                        >
                            Produtos
                        </Button>
                    </NavItem>
                    <NavItem>
                        <Button
                            variant="success"
                            data-value="3"
                            disabled={navState === 3}
                            onClick={handleNav}
                        >
                            Termos e condições de uso
                        </Button>
                    </NavItem>
                    <NavItem>
                        <Button
                            variant="success"
                            data-value="4"
                            disabled={navState === 4}
                            onClick={handleNav}
                        >
                            Cartões
                        </Button>
                    </NavItem>
                    <NavItem>
                        <Button
                            variant="success"
                            data-value="5"
                            disabled={navState === 5}
                            onClick={handleNav}
                        >
                            Popup de cookies
                        </Button>
                    </NavItem>
                    <NavItem>
                        <Button
                            variant="success"
                            data-value="6"
                            disabled={navState === 6}
                            onClick={handleNav}
                        >
                            Universidade Ecobrite
                        </Button>
                    </NavItem>
                </nav>
                <hr />
                <SectionNav show={navState === 1}>
                    <SettingsSpotlight />
                </SectionNav>
                <SectionNav show={navState === 2}>
                    <SettingsProductsAndMarkets />
                </SectionNav>
                <SectionNav show={navState === 3}>
                    <SettingsTermsOfUseCDOC />
                </SectionNav>
                <SectionNav show={navState === 4}>
                    <SettingsCards />
                </SectionNav>
                <SectionNav show={navState === 5}>
                    <SettingsPopupCookies />
                </SectionNav>
                <SectionNav show={navState === 6}>
                    <SettingsCDOC />
                </SectionNav>
            </Main>
        </Container>
    );
}

export default Index;
